import React, { useEffect, useState,useRef,useCallback } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  AlertListViewActive,
  ClearFilter,
  DeleteIcon,
  DropArrow,
  FilterClearIcon,
  FilterIcon,
  InfoIcon1,
  Save,
  SaveFilter,
  SearchIcon,
  WarningDelete,
  RemoveIcon,
} from "../../assets/images";
import FilterToolDDL from "../../components/Filter/FilterToolDDL";
import { filterActions } from "../../redux/features/shared/filter";
import { modalActions } from "../../redux/features/shared/modal";
import { getCSIds, isNotNullOrEmpty, parseSCSEntitiesToObect } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from "react-multi-select-component";
import DynamicWidgetStructure from "./DynamicWidgetStructure";
import {
  getAlertsData,
  getWidgetList,
  getDeviceStatusData,
  getConsolidatedData,
  getVideoBackupData,
  getVideoBackupActivityTimeline,
  getAddLayout,
  getAddedLayout,
  getUpdateLayout,
  getDashboardFilters,
} from "../../services/dashboardService";
import {
  deleteSavedFilter,
  fetchClientList,
  fetchSavedFiltersList,
  fetchSiteList,
  saveFilter,
} from "../../services/filterService";
import { DashboardWidgetsActions } from "../../redux/features/DashboardWidgets";
import { buttonActions } from "../../redux/features/shared/button";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import CircularProgress from "@mui/material/CircularProgress";
import CountdownTimer from "../../components/Common/CountdownTimer";
import Modal from "react-bootstrap/Modal";
import { getInfoList } from "../../services/alertGridServices";
import InfoComponent from "../Alerts/Common/InfoComponent";
import AlertTemplateMessage from "../Configuration/AlertTemplate/AlertTemplateMessage";
import { DASHBOARD_INTERVAL_TIMER } from "../../config";

const COUNTRY = "Country";
const REGION = "Region";
const STATE = "State";
const CUSTOMER = "Customer";
const SITE = "Site";
const SAVEDFILTER = "Saved Filter";
const DashboardWidgets = "Consolidated Dashboard";

const DashboardFilterState = {
  savedFilters: {
    options: [],
    selected: null,
  },
  customer: {
    options: [],
    selected: [],
  },
  site: {
    options: [],
    selected: [],
  },
  country: {
    options: [],
    selected: [],
  },
  state: {
    options: [],
    selected: [],
  },
  region: {
    options: [],
    selected: [],
  },
};

const buttonVisibility = {
  visibleFilterBtn: true,
  visibleClearFilterBtn: true,
  visibleSaveFilterBtn: true,
  visibleSingleViewBtn: true,
};


// ----------- Excel-like Filter Utility -----------
function getFilteredOptions(dashboardFilters, filterState, filterKey, optionKey, labelKey) {
  // Build a filter object with only selected values for each filter
  const activeSelections = {};
  Object.keys(filterState).forEach(key => {
    const selected = filterState[key]?.selected;
    if (
      key !== filterKey &&
      Array.isArray(selected) &&
      selected.length > 0
    ) {
      activeSelections[key] = selected.map(sel =>
        typeof sel === "object" ? sel.value : sel
      );
    }
  });

  // Filter dashboardFilters based on all other active selections
  const filtered = (dashboardFilters || []).filter(item => {
    return Object.entries(activeSelections).every(([key, selectedVals]) => {
      if (key === "customer") return selectedVals.includes(item.ClientId);
      if (key === "country") return selectedVals.includes(item.countrymasterid);
      if (key === "region") return selectedVals.includes(item.Region);
      if (key === "state") return selectedVals.includes(item.statemasterid);
      if (key === "site") return selectedVals.includes(item.SiteID);
      return true;
    });
  });

  // Get unique options for this filter
  const seen = new Set();
  return filtered
    .filter(item => {
      const val = item[optionKey];
      if (!val || seen.has(val)) return false;
      seen.add(val);
      return true;
    })
    .map(item => ({
      label: item[labelKey],
      value: item[optionKey],
    }));
}
// -----------------------------------------------

const Dashboard = ({ isDarkTheme }) => {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [widgetList, setWidgetList] = useState([]);
  const [alertsData, setAlertsData] = useState(null);
  const [deviceStatus, setDeviceStatus] = useState(null);
  const [consolidatedData, setConsolidatedData] = useState(null);
  const [VBData, setVBData] = useState(null);
  const [VBTimeLineData, setVBTimeLineData] = useState(null);
  const [addLayout, setAddLayout] = useState(null);
  const [updateLayout, setUpdateLayout] = useState(null);
  const [getLayout, setGetLayout] = useState(null);
  const [getLayoutLoading, setGetLayoutLoading] = useState(true);
  const [filteredLayout, setFilteredLayout] = useState(null);

  const [alertsPayload, setAlertsPayload] = useState(null);
  const [deviceStatusPayload, setDeviceStatusPayload] = useState(null);
  const [consolidatedDataPayload, setConsolidatedDataPayload] = useState(null);
  const [VBDataPayload, setVBDataPayload] = useState(null);
  const [VBTimeLineDataPayload, setVBTimeLineDataPayload] = useState(null);

  const [selectedwidgets, setSelectedWidgets] = useState(null);
  const [refreshCountdown, setRefreshCountdown] = useState(0);

  const [widgetListLoading, setWidgetListLoading] = useState(false);
  const [widgetListError, setWidgetListError] = useState(null);

  const [openInfoFilter, setOpenInfoFilter ] = useState(false);
  const [modalFilterName, setModalFilterName] = useState("");
  const [customerInfoArr, setCustomerInfoArr] = useState([]);
  const [siteInfoArr, setSiteInfoArr] = useState([]);
  const [countryInfoArr, setCountryInfoArr] = useState([]);
  const [stateInfoArr, setStateInfoArr] = useState([]);
  const [regionInfoArr, setRegionInfoArr] = useState([]);


  const [dashboardFilters, setDashboardFilters] = useState(null);

  const [DashboardWidgetsFilterState, setDashboardWidgetsFilterState] =
    useState(DashboardFilterState);
  const [buttonVisibilityState, setButtonVisibilityState] =
    useState(buttonVisibility);

  const [showSavedFilterSaveModal, setShowSavedFilterSaveModal] =
    useState(false);
  const [showSavedFilterDeleteModal, setShowSavedFilterDeleteModal] =
    useState(false);
  const [filterName, setFilterName] = useState("");

  const todayInit = new Date();
  todayInit.setHours(0, 0, 0, 0);
  const [selectedDate, setSelectedDate] = useState(todayInit);

  
  const selectedDateRef = useRef(selectedDate);
  useEffect(() => {
    selectedDateRef.current = selectedDate;
  }, [selectedDate]);
  
  const { visibleFilterBtn, visibleClearFilterBtn, visibleSaveFilterBtn } =
    buttonVisibilityState;

  const filter = useSelector((state) => state?.filter);
  const { savedFilters } = filter;

  const [apiFilter, setApiFilter] = useState({
    SiteID: [],
    CustomerID: [],
    Region: [],
    StateID: [],
    CountryID: [],
  });

  const [timerKey, setTimerKey] = useState(0);

  //#region redux state and dispatcher function
  const dispatch = useDispatch();
  const { customer, site, region, state, country } =
    DashboardWidgetsFilterState;

   // ----------- Filter Option Updaters -----------
  const updateAllFilterOptions = () => {
    if (!dashboardFilters) return;
    updateCustomerOptions(getFilteredOptions(dashboardFilters, DashboardWidgetsFilterState, "customer", "ClientId", "ClientName"));
    updateCountryOptions(getFilteredOptions(dashboardFilters, DashboardWidgetsFilterState, "country", "countrymasterid", "countryname"));
    updateRegionOptions(getFilteredOptions(dashboardFilters, DashboardWidgetsFilterState, "region", "Region", "Region"));
    updateStateOptions(getFilteredOptions(dashboardFilters, DashboardWidgetsFilterState, "state", "statemasterid", "statename"));
    updateSiteOptions(getFilteredOptions(dashboardFilters, DashboardWidgetsFilterState, "site", "SiteID", "SiteName"));
  };
  // ----------------------------------------------  

  const getSiteOptions1 = () => {
    // Get selected IDs/values
    const selectedCustomerIds = (customer.selected || []).map((c) =>
      typeof c === "object" ? c.value : c
    );
    const selectedCountryIds = (country.selected || []).map((c) =>
      typeof c === "object" ? c.value : c
    );
    const selectedRegion = (region.selected || []).map((r) =>
      typeof r === "object" ? r.value ?? r.label : r
    );
    const selectedStateIds = (state.selected || []).map((s) =>
      typeof s === "object" ? s.value : s
    );

    // Filter dashboardFilters for matching selections
    const filteredSites = (dashboardFilters || []).filter((item) => {
      return (
        selectedCustomerIds.includes(item.ClientId) &&
        selectedCountryIds.includes(item.countrymasterid) &&
        selectedRegion.includes(item.Region) &&
        selectedStateIds.includes(item.statemasterid)
      );
    });

    // Get unique site options
    const seen = new Set();
    const siteOptions = filteredSites
      .filter((item) => {
        if (!item.SiteID || !item.SiteName) return false;
        if (seen.has(item.SiteID)) return false;
        seen.add(item.SiteID);
        return true;
      })
      .map((item) => ({
        label: item.SiteName,
        value: item.SiteID,
      }));

    return siteOptions;
  };


  const getCustomerOptions1 = () => {
    // Get selected region values (could be label or value)
    const selectedRegions = (region.selected || []).map((r) =>
      typeof r === "object" ? r.value ?? r.label : r
    );

    // Filter dashboardFilters for matching Region
    const filteredCustomers = (dashboardFilters || []).filter((item) =>
      selectedRegions.includes(item.Region)
    );

    // Get unique customer options
    const seen = new Set();
    const customerOptions = filteredCustomers
      .filter((item) => {
        if (!item.ClientId || !item.ClientName) return false;
        if (seen.has(item.ClientId)) return false;
        seen.add(item.ClientId);
        return true;
      })
      .map((item) => ({
        label: item.ClientName,
        value: item.ClientId,
      }));

    return customerOptions;
  };


  const updateSelectedSite = (selectedSites) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      site: {
        ...prev.site,
        selected: selectedSites,
      },
    }));
  };

  const updateSiteOptions = (siteOptions) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      site: {
        ...prev.site,
        options: siteOptions,
      },
    }));
  };
  // Country
  const updateSelectedCountry = (selectedCountries) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      country: {
        ...prev.country,
        selected: selectedCountries,
      },
    }));
  };

  const updateCountryOptions = (countryOptions) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      country: {
        ...prev.country,
        options: countryOptions,
      },
    }));
  };

  // State
  const updateSelectedState = (selectedStates) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      state: {
        ...prev.state,
        selected: selectedStates,
      },
    }));
  };

  const updateStateOptions = (stateOptions) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      state: {
        ...prev.state,
        options: stateOptions,
      },
    }));
  };

  // Region
  const updateSelectedRegion = (selectedRegions) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      region: {
        ...prev.region,
        selected: selectedRegions,
      },
    }));
  };

  const updateRegionOptions = (regionOptions) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      region: {
        ...prev.region,
        options: regionOptions,
      },
    }));
  };

  // Customer
  const updateSelectedCustomer = (selectedCustomers) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      customer: {
        ...prev.customer,
        selected: selectedCustomers,
      },
    }));
  };

  const updateCustomerOptions = (customerOptions) => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      customer: {
        ...prev.customer,
        options: customerOptions,
      },
    }));
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const UserID = user?.Id;

  const getFilters = () => {
    return {
      SiteID: (site?.selected || []).map((s) =>
        typeof s === "object" ? s.value : s
      ),
      CustomerID: (customer?.selected || []).map((c) =>
        typeof c === "object" ? c.value : c
      ),
      Region: (region?.selected || []).map((r) =>
        typeof r === "object" ? r.value : r
      ),
      StateID: (state?.selected || []).map((s) =>
        typeof s === "object" ? s.value : s
      ),
      CountryID: (country?.selected || []).map((c) =>
        typeof c === "object" ? c.value : c
      ),
    };
  };

  const fetchAlertsData = (dateRangeValue, payload, globalFilter = {}) => {
    const now = new Date();
    // ToDateTime: today at 23:59:59
    const toDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999
    );
    // FromDateTime: (today - (dateRangeValue - 1)) at 00:00:00
    const fromDate = new Date(toDate);
    fromDate.setDate(
      toDate.getDate() - (dateRangeValue ? dateRangeValue - 1 : 0)
    );
    fromDate.setHours(0, 0, 0, 0);

    // Convert to UTC ISO string
    const toDateUTC = toDate.toISOString().replace('T', ' ').substring(0, 19);
    const fromDateUTC = fromDate.toISOString().replace('T', ' ').substring(0, 19);


    const formatDate = (date) => {
      const pad = (n) => n.toString().padStart(2, "0");
      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        " " +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds())
      );
    };

    getAlertsData({
      UserID: UserID,
      widgets: payload,
      DateRange: dateRangeValue,
      //FromDateTime: fromDateUTC,
      //ToDateTime: toDateUTC,
      FromDateTime: formatDate(fromDate),
      ToDateTime: formatDate(toDate),
      filters: globalFilter,
    })
      .then((res) => {
        if (res && res.Status === "success") {
          setAlertsData((prev) => ({
            ...prev,
            [dateRangeValue]: res.Data, // Store by DateRange
          }));
        }
      })
      .catch((err) => console.log(err));
  };
  const fetchDeviceStatusData = (globalFilter = {}) => {
    getDeviceStatusData({
      UserID: UserID,
      widgets: deviceStatusPayload,
      filters: globalFilter,
    })
      .then((res) => {
        if (res && res.Status === "success") {
          setDeviceStatus(res.Data);
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchConsolidatedData = (globalFilter = {}) => {
    getConsolidatedData({
      UserID: UserID,
      widgets: consolidatedDataPayload,
      filters: globalFilter,
    })
      .then((res) => {
        if (res && res.Status === "success") {
          setConsolidatedData(res.Data);
        }
      })
      .catch((err) => console.log(err));
  };

  
// Format helper
function formatDateTime(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
}


  const fetchVBData = (globalFilter = {}) => {
  const now = new Date();

  // FromDateTime: 24 hours ago
  const fromDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);

  const FromDateTime = formatDateTime(fromDate);
  const ToDateTime   = formatDateTime(now);
    
    getVideoBackupData({
      UserID: UserID,
      widgets: VBDataPayload,
      FromDateTime,
      ToDateTime,
      filters: globalFilter,
    })
      .then((res) => {
        if (res && res.Status === "success") {
          setVBData(res.Data);
        }
      })
      .catch((err) => console.log(err));
  };


const fetchVBTimeLineData = useCallback(() => {
  const payload      = VBTimeLineDataPayload || [];
  const globalFilter = getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState);
 
  const date = selectedDateRef.current;   // always the latest date

  // FromDateTime → midnight of selected date
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  const FromDateTime = formatDateTime(startOfDay);

  const now = new Date();
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  let ToDateTime;
  if (isToday) {
    // Current time if today
    ToDateTime = formatDateTime(now);
  } else {
    // End of day if not today
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    ToDateTime = formatDateTime(endOfDay);
  }
 
  getVideoBackupActivityTimeline({
    UserID,
    widgets: payload,
    FromDateTime,
    ToDateTime,
    filters: globalFilter,
  }).then(res => {
        if (res && res.Status === "success") {
          setVBTimeLineData(res);
        }
      });
}, [VBTimeLineDataPayload, apiFilter, DashboardWidgetsFilterState, UserID]);

  const getUniqueOptions = (arr, key) => {
    const seen = new Set();
    return arr.filter((item) => {
      const val = item[key];
      if (val === undefined || val === null || val === "") return false;
      if (seen.has(val)) return false;
      seen.add(val);
      return true;
    });
  };

  const setDashboardFiltersInReducer = (filters) => {
    const siteOptions = getUniqueOptions(filters, "SiteID").map((item) => ({
      label: item.SiteName,
      value: parseInt(item.SiteID),
    }));

    const clientOptions = getUniqueOptions(filters, "ClientId").map((item) => ({
      label: item.ClientName,
      value: parseInt(item.ClientId),
    }));

    const regionOptions = getUniqueOptions(filters, "Region").map((item) => ({
      label: item.Region,
      value: item.Region,
    }));

    const stateOptions = getUniqueOptions(filters, "statemasterid").map(
      (item) => ({
        label: item.statename,
        value: parseInt(item.statemasterid),
      })
    );

    const countryOptions = getUniqueOptions(filters, "countrymasterid").map(
      (item) => ({
        label: item.countryname,
        value: parseInt(item.countrymasterid),
      })
    );

    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      country: { ...prev.country, options: countryOptions },
      state: { ...prev.state, options: stateOptions },
      region: { ...prev.region, options: regionOptions },
      customer: { ...prev.customer, options: clientOptions },
      site: { ...prev.site, options: siteOptions },
    }));
  };

  useEffect(() => {
    setRefreshCountdown(0); // Start from 1
    const interval = setInterval(() => {
      //setRefreshCountdown((prev) => (prev < 10 ? prev + 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);


   
  useEffect(() => {
    if (VBTimeLineDataPayload && VBTimeLineDataPayload.length > 0) {
      fetchVBTimeLineData();
    }
  }, [selectedDate]);   // ← fires every time the user picks a new date
  

  // After both widgetList and getLayout are loaded:
  useEffect(() => {
    if (widgetList && getLayout && Array.isArray(getLayout.layout)) {
      const validWidgetIDs = widgetList.map(w => String(w.WidgetID));
      const filteredLayoutObj = {
        ...getLayout,
        layout: getLayout.layout.filter(l => validWidgetIDs.includes(String(l.i))),
        items: getLayout.items
          ? getLayout.items.filter(item => validWidgetIDs.includes(String(item.i)))
          : [],
      };
      setFilteredLayout(filteredLayoutObj);
    }
  }, [widgetList, getLayout]);

  // Utility function to get LayoutPreference from localStorage
  const getLayoutPreferenceFromStorage = () => {
    const layoutArray = localStorage.getItem("dashboard-layout")
      ? JSON.parse(localStorage.getItem("dashboard-layout"))
      : [];
    const counter = localStorage.getItem("dashboard-counter")
      ? JSON.parse(localStorage.getItem("dashboard-counter"))
      : 0;
    return {
      w: layoutArray.map((item) => item.w),
      h: layoutArray.map((item) => item.h),
      x: layoutArray.map((item) => item.x),
      y: layoutArray.map((item) => item.y),
      i: layoutArray.map((item) => item.i),
      minH:layoutArray.map((item) => item.minH),
      minW:layoutArray.map((item) => item.minW),
      moved: layoutArray.map((item) => item.moved),
      static: layoutArray.map((item) => item.static),
      counter: counter,
    };
  };

  const addLayoutData = () => {
    const LayoutPreference = getLayoutPreferenceFromStorage();

    getAddLayout({
      UserID: UserID,
      LayoutPreference: LayoutPreference,
    })
      .then((res) => {
        if (res && res.Status === "success") {
          setAddLayout(res.Data);
          SuccessToast(res.Message);
        }
      })
      .catch((err) => ErrorToast("Error in Saving layout"));
  };

  const updateLayoutData = () => {
    const LayoutPreference = getLayoutPreferenceFromStorage();
    getUpdateLayout({
      UserID: UserID,
      LayoutPreference: LayoutPreference,
    })
      .then((res) => {
        if (res && res.Status === "success") {
          setUpdateLayout(res.Data);
          SuccessToast(res.Message);
        }
      })
      .catch((err) => ErrorToast("Error in Saving layout"));
  };

  useEffect(() => {
    if (
      alertsPayload &&
      alertsPayload.length > 0 &&
      widgetList &&
      widgetList.length > 0
    ) {
      const dateRanges = [
        ...new Set(
          widgetList.filter((w) => w.DateRange).map((w) => w.DateRange)
        ),
      ];
      dateRanges.forEach((dateRangeValue) => {
        const filteredPayload = alertsPayload.filter((payload) => {
          const widget = widgetList.find(
            (w) => w.WidgetID === payload.WidgetID
          );
          return widget && widget.DateRange === dateRangeValue;
        });
        if (filteredPayload.length > 0) {
          fetchAlertsData(dateRangeValue, filteredPayload, getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
        }
      });
    }
  }, [alertsPayload, widgetList]);

  useEffect(() => {
    if (deviceStatusPayload && deviceStatusPayload.length > 0) {
      fetchDeviceStatusData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
    }
  }, [deviceStatusPayload]);

  useEffect(() => {
    if (consolidatedDataPayload && consolidatedDataPayload.length > 0) {
      fetchConsolidatedData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
    }
  }, [consolidatedDataPayload]);
  useEffect(() => {
    if (VBDataPayload && VBDataPayload.length > 0) {
      fetchVBData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
    }
  }, [VBDataPayload]);

  useEffect(() => {
    if (VBTimeLineDataPayload && VBTimeLineDataPayload.length > 0) {
          fetchVBTimeLineData();
    }
  }, [VBTimeLineDataPayload]);

  useEffect(() => {
    setWidgetListLoading(true);
    setWidgetListError(null);
    getWidgetList({ UserID })
      .then((res) => {
        if (res && res.Status === "success") {
          setWidgetList(res?.Data);
        } else {
          setWidgetListError("Failed to load widgets.");
        }
        setWidgetListLoading(false);
      })
      .catch((err) => {
        setWidgetListError("Error loading widgets.");
        setWidgetListLoading(false);
        console.log("Error in Dashboard component: ", err);
      });

    getDashboardFilters({ UserID })
      .then((res) => {
        if (res && res.Status === "success") {
          setDashboardFilters(res.Data);
          setDashboardFiltersInReducer(res.Data);
        }
      })
      .catch((err) => {
        console.log("Error fetching dashboard filters: ", err);
      });

    fetchAddedLayout(UserID);
    //dispatch(fetchClientList());
    dispatch(fetchSavedFiltersList(DashboardWidgets));

    return () =>{
      dispatch(filterActions.resetFilterStates());
      resetFilter();
      handleClearFilterClick();
      // Remove dashboard layout data from localStorage on unmount
      localStorage.removeItem('dashboard-counter');
      localStorage.removeItem('dashboard-layout');
      localStorage.removeItem('dashboard-items');
    }
  }, []);

  const fetchAddedLayout = (UserID) => {
    setGetLayoutLoading(true);
    getAddedLayout({ UserID })
      .then((res) => {
        if (res && res.Status === "success") {
          const result = res?.Data?.LayoutPreference || {};
          const { counter } = result;
          let originalArray = [];
          let iArray = [];

          if (Array.isArray(result.i)) {
            originalArray = result.i.map((_, idx) => ({
              w: result.w[idx],
              h: result.h[idx],
              y: result.y[idx],
              x: result.x[idx],
              i: result.i[idx],
              minH: result.minH[idx],
              minW: result.minW[idx],
              moved: result.moved[idx],
              static: result.static[idx],
            }));

            iArray = result.i.map((i) => ({ i }));
          }

          setGetLayout({
            layout: originalArray,
            items: iArray,
            counter: counter,
          });

          localStorage.setItem('dashboard-counter', counter);
          localStorage.setItem('dashboard-layout', JSON.stringify(originalArray));
          localStorage.setItem('dashboard-items', JSON.stringify(iArray));
        }
        setGetLayoutLoading(false);
      })
      .catch((err) => {
        setGetLayoutLoading(false);
        console.log("Error in getting layout: ", err);
      });
  };

  const hasSavedLayout =
    filteredLayout && Array.isArray(filteredLayout.layout) && filteredLayout.layout.length > 0;

  const shouldFilterAndClearFilterBtnsBeEnabled = () => {
    let isEnabled = false;
    if (isNotNullOrEmpty(savedFilters?.selected)) {
      isEnabled = false;
    }

    if (isNotNullOrEmpty(customer?.selected)) {
      isEnabled = true;
    }
    if (isNotNullOrEmpty(country?.selected)) {
      isEnabled = true;
    }
    if (isNotNullOrEmpty(state?.selected)) {
      isEnabled = true;
    }
    if (isNotNullOrEmpty(site?.selected)) {
      isEnabled = true;
    }
    if (isNotNullOrEmpty(region?.selected)) {
      isEnabled = true;
    }
    return isEnabled;
  };

  const isSaveFilterBtnEnabled = () => {
    let isEnabled = false;
    if (isNotNullOrEmpty(savedFilters?.selected)) {
      isEnabled = false;
    } else if (
      isNotNullOrEmpty(customer?.selected) ||
      isNotNullOrEmpty(site?.selected) ||
      isNotNullOrEmpty(state?.selected) ||
      isNotNullOrEmpty(region?.selected) ||
      isNotNullOrEmpty(country?.selected)
    ) {
      isEnabled = true;
    } else {
      isEnabled = false;
    }
    return isEnabled;
  };

  const infoFilterList = (pId) => {
      getInfoList(pId)
        .then((res) => {
          if (res.Status == "success") {
            infoDataFilter(res.Data);
          } else {
            ErrorToast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
  
  
    const infoDataFilter = (arr) => {

      let customerArr = arr.filter((item) => item.Entity == 'Client');
      setCustomerInfoArr(customerArr);

      let siteArr = arr.filter((item) => item.Entity == SITE);
      setSiteInfoArr(siteArr);

      let reigonArr = arr.filter((item) => item.Entity == REGION);
      setRegionInfoArr(reigonArr);

      let stateArr = arr.filter((item) => item.Entity == STATE);
      setStateInfoArr(stateArr);

      let countryArr = arr.filter((item) => item.Entity == COUNTRY);
      setCountryInfoArr(countryArr);
    };

  const disableFilterBtn = (isVisible) => {
    setButtonVisibilityState((prev) => ({
      ...prev,
      visibleFilterBtn: isVisible,
    }));
  };

  const disableClearFilterBtn = (isVisible) => {
    setButtonVisibilityState((prev) => ({
      ...prev,
      visibleClearFilterBtn: isVisible,
    }));
  };

  const disableSaveFilterBtn = (isVisible) => {
    setButtonVisibilityState((prev) => ({
      ...prev,
      visibleSaveFilterBtn: isVisible,
    }));
  };

  useEffect(() => {
    //true is disabled, false is enable

    if (
      !isNotNullOrEmpty(savedFilters?.selected) &&
      !isNotNullOrEmpty(customer?.selected) &&
      !isNotNullOrEmpty(site?.selected) &&
      !isNotNullOrEmpty(state?.selected) &&
      !isNotNullOrEmpty(region?.selected) &&
      !isNotNullOrEmpty(country?.selected)
    ) {
      setApiFilter({
        SiteID: [],
        CustomerID: [],
        Region: [],
        StateID: [],
        CountryID: [],
      });}

    //Reset all filter buttons
    if (
      !isNotNullOrEmpty(savedFilters?.selected) &&
      !isNotNullOrEmpty(customer?.selected)
    ) {
      dispatch(buttonActions.resetAllButtons());
    }

    //Enable or disable filter and clear filter buttons
    if (shouldFilterAndClearFilterBtnsBeEnabled()) {
      disableFilterBtn(false);
      disableClearFilterBtn(false);
      //dispatch(buttonActions.disableClearFilterBtn(false));
    } else {
      disableFilterBtn(true);
      disableClearFilterBtn(true);
      //dispatch(buttonActions.disableClearFilterBtn(true));
    }

    //Enable or disable save filter button
    if (isSaveFilterBtnEnabled()) {
      //dispatch(buttonActions.disableSaveFilterBtn(false));
      disableSaveFilterBtn(false);
    } else {
      //dispatch(buttonActions.disableSaveFilterBtn(true));
      disableSaveFilterBtn(true);
    }

    //Fetch saved filters list
    if (!isNotNullOrEmpty(savedFilters?.options)) {
      dispatch(fetchSavedFiltersList(DashboardWidgets));
    }
  }, [
    savedFilters?.selected,
    customer?.selected,
    site?.selected,
    state?.selected,
    region?.selected,
    country?.selected,
  ]);

  //#endregion

  useEffect(() => {
    let tempUser = JSON.parse(localStorage.getItem("user"));
    if (tempUser) {
      let check =
        tempUser?.UserRoleID == 1 ||
        tempUser?.UserRoleID == 2 ||
        tempUser?.roleId == 1 ||
        tempUser?.roleId == 2;
      setLoggedInUser(tempUser);
    }
  }, [localStorage.getItem("user")]);

  const getOpenMenu = () => {
    setOpen(true);
  };

  // ----------- Main Filter Change Handler -----------
  const handleFilterItemChange = (value, filter) => {
    if(savedFilters?.selected){
      handleClearSavedFilterClick();
        setApiFilter({
        SiteID: [],
        CustomerID: [],
        Region: [],
        StateID: [],
        CountryID: [],
      });
    }
    switch (filter) {
      case CUSTOMER:
        updateSelectedCustomer(value);
        //updateSelectedCountry([]);
        //updateSelectedRegion([]);
        //updateSelectedState([]);
        //updateSelectedSite([]);
        
        break;
      case COUNTRY:
        updateSelectedCountry(value);
        //updateSelectedRegion([]);
        //updateSelectedState([]);
        //updateSelectedSite([]);
        break;
      case REGION:
        updateSelectedRegion(value);
        //updateSelectedState([]);
        //updateSelectedSite([]);
        break;
      case STATE:
        updateSelectedState(value);
        //updateSelectedSite([]);
        break;
      case SITE:
        updateSelectedSite(value);
        break;
      default:
        break;
    }
    
    // After any filter change, update all filter options
    //setTimeout(updateAllFilterOptions, 0);
  };

  useEffect(() => {
    if (dashboardFilters) {
      updateAllFilterOptions();
    }


  }, [
    dashboardFilters,
    DashboardWidgetsFilterState.customer.selected,
    DashboardWidgetsFilterState.country.selected,
    DashboardWidgetsFilterState.region.selected,
    DashboardWidgetsFilterState.state.selected,
    DashboardWidgetsFilterState.site.selected,
  ]);

  useEffect(()=>{
    setTimerKey((prev) => prev + 1);
    setRefreshCountdown(0);

    console.log({savedFilters})

    if((alertsPayload && alertsPayload.length > 0) ||
    (deviceStatusPayload && deviceStatusPayload.length > 0) ||
    (consolidatedDataPayload && consolidatedDataPayload.length > 0) ||
     (VBDataPayload && VBDataPayload.length > 0) ||
     (VBTimeLineDataPayload && VBTimeLineDataPayload.length > 0)){
    }

    if (
      alertsPayload &&
      alertsPayload.length > 0 &&
      widgetList &&
      widgetList.length > 0
    ) {
      const dateRanges = [
        ...new Set(
          widgetList.filter((w) => w.DateRange).map((w) => w.DateRange)
        ),
      ];
      dateRanges.forEach((dateRangeValue) => {
        const filteredPayload = alertsPayload.filter((payload) => {
          const widget = widgetList.find(
            (w) => w.WidgetID === payload.WidgetID
          );
          return widget && widget.DateRange === dateRangeValue;
        });
        if (filteredPayload.length > 0) {
          fetchAlertsData(dateRangeValue, filteredPayload, getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
        }
      });
    }
    if (deviceStatusPayload && deviceStatusPayload.length > 0) {
      fetchDeviceStatusData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
    }
    if (consolidatedDataPayload && consolidatedDataPayload.length > 0) {
      fetchConsolidatedData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
    }
    if (VBDataPayload && VBDataPayload.length > 0) {
      fetchVBData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
    }
    if (VBTimeLineDataPayload && VBTimeLineDataPayload.length > 0) {
        fetchVBTimeLineData();
    }

  },[apiFilter])


  const handleFilterClick = () => {
    // Reset the countdown timer
    // Update API filter state
    setApiFilter({
      ...apiFilter,
      ...getFilters(),
    });


    // Call APIs to fetch data based on new filters
    
  };

  const handleClearFilterClick = () => {
    setApiFilter({
      SiteID: [],
      CustomerID: [],
      Region: [],
      StateID: [],
      CountryID: [],
    });

    updateSelectedSite([]);
    updateSelectedCountry([]);
    updateSelectedCustomer([]);
    updateSelectedRegion([]);
    updateSelectedState([]);
  };

  const infoDataGet = (item) => {};

  const resetFilter = () => {
    setDashboardWidgetsFilterState((prev) => ({
      ...prev,
      customer: { ...prev.customer, selected: [] },
      country: { ...prev.country, selected: [], options: [] },
      state: { ...prev.state, selected: [], options: [] },
      region: { ...prev.region, selected: [], options: [] },
      site: { ...prev.site, selected: [], options: [] },
    }));
    
  };

  const handleClearSavedFilterClick = () => {
    
    resetFilter();
    dispatch(filterActions.resetSavedFilter());
    updateSelectedCustomer([]);
    updateSelectedCountry([]);
    updateSelectedState([]);
    updateSelectedRegion([]);
    updateSelectedSite([]);
  };

  const handleSavedFilterItemSelectClick = (e, item) => {
    dispatch(filterActions.setSavedFilterSelected(item));
    resetFilter();
    let filterData = parseSCSEntitiesToObect(item?.filterValues);
    if (isNotNullOrEmpty(filterData)) {
      // Convert comma separated strings to arrays and cast to correct types
      let clientIds = filterData?.Client
        ? typeof filterData.Client === "string"
          ? filterData.Client.split(",").map((id) => parseInt(id.trim(), 10)).filter((id) => !isNaN(id))
          : Array.isArray(filterData.Client)
            ? filterData.Client.map((id) => parseInt(id, 10)).filter((id) => !isNaN(id))
            : []
        : [];
      let siteIds = filterData?.Site
        ? typeof filterData.Site === "string"
          ? filterData.Site.split(",").map((id) => parseInt(id.trim(), 10)).filter((id) => !isNaN(id))
          : Array.isArray(filterData.Site)
            ? filterData.Site.map((id) => parseInt(id, 10)).filter((id) => !isNaN(id))
            : []
        : [];
      let region = filterData?.Region
        ? typeof filterData.Region === "string"
          ? filterData.Region.split(",").map((id) => id.trim()).filter(Boolean)
          : Array.isArray(filterData.Region)
            ? filterData.Region.map((id) => String(id))
            : []
        : [];
      let countryIds = filterData?.Country
        ? typeof filterData.Country === "string"
          ? filterData.Country.split(",").map((id) => parseInt(id.trim(), 10)).filter((id) => !isNaN(id))
          : Array.isArray(filterData.Country)
            ? filterData.Country.map((id) => parseInt(id, 10)).filter((id) => !isNaN(id))
            : []
        : [];
      let stateIds = filterData?.State
        ? typeof filterData.State === "string"
          ? filterData.State.split(",").map((id) => parseInt(id.trim(), 10)).filter((id) => !isNaN(id))
          : Array.isArray(filterData.State)
            ? filterData.State.map((id) => parseInt(id, 10)).filter((id) => !isNaN(id))
            : []
        : [];

      // Set API filter as required
      setApiFilter({
        SiteID: siteIds,
        CustomerID: clientIds,
        Region: region,
        StateID: stateIds,
        CountryID: countryIds,
      });

      //handleFilterClick();
    }
  };



  // In filterToolDDLProps, use the updated options from state
  const filterToolDDLProps = {
    visibleDDLSingleSelect: true,
    visibleDDLMultiSelect: true,
    DDLSingleSelectProps: {
      labelledBy:
        savedFilters?.selected?.filterName !== undefined
          ? `${SAVEDFILTER}: ` + savedFilters?.selected?.filterName
          : `${SAVEDFILTER}`,
      selected: isNotNullOrEmpty(savedFilters?.selected)
        ? savedFilters?.selected
        : null,
      emptyOptionLabel: "No Saved Filters",
      handleClearSelectedClick: handleClearSavedFilterClick,
      clearDisabled: !isNotNullOrEmpty(savedFilters?.selected),
      options: savedFilters?.options,
      valueRenderer: null,
      itemRenderer: (item) => (
        <>
          <div
            className="SavedFilterOption"
            onClick={(e) => handleSavedFilterItemSelectClick(e, item)}
            key={item?.filterId}
          >
            <span>{item?.filterName}</span>
            <div className="SaveFilterOtionHover">
              <button
                style={{ background: "transparent" }}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(filterActions.setSavedFilterSelected(item));
                  setShowSavedFilterDeleteModal(true);
                }}
              >
                <img src={DeleteIcon} />
              </button>
              <button
                style={{ background: "transparent" }}
                onClick={(e) => {
                  e.stopPropagation();
                  infoFilterList(item.filterId)
                  setOpenInfoFilter(true);
                  setModalFilterName(item.filterName);
                }}
              >
                <img src={InfoIcon1} />
              </button>
            </div>
          </div>
        </>
      ),
    },
    filterList: [
      {
        labelledBy: CUSTOMER,
        options: customer?.options || [],
        value: customer?.selected,
        onChange: (value) => handleFilterItemChange(value, CUSTOMER),
        valueRenderer: null,
        className:
          customer?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: COUNTRY,
        options: country?.options || [],
        value: country?.selected,
        onChange: (value) => handleFilterItemChange(value, COUNTRY),
        valueRenderer: null,
        className:
          country?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: REGION,
        options: region?.options || [],
        value: region?.selected,
        onChange: (value) => handleFilterItemChange(value, REGION),
        valueRenderer: null,
        className:
          region?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: STATE,
        options: state?.options || [],
        value: state?.selected,
        onChange: (value) => handleFilterItemChange(value, STATE),
        valueRenderer: null,
        className:
          state?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: SITE,
        options: site?.options || [],
        value: site?.selected,
        onChange: (value) => handleFilterItemChange(value, SITE),
        valueRenderer: null,
        className:
          site?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
    ],
  };


  const handleFilterNameInputChange = (e) => {
    setFilterName(e.target.value);
  };

  const openSaveModal = () => {
    setShowSavedFilterSaveModal(true);
  };

  const handleDeleteSavedFilterModalYesClick = (e) => {
    let filterId = savedFilters?.selected?.filterId;
    dispatch(deleteSavedFilter(filterId));
    setShowSavedFilterDeleteModal(false);
    handleClearFilterClick();
  };

  const handleDeleteSavedFilterNoClick = (e) => {
    setShowSavedFilterDeleteModal(false);
  };

  const handleSaveFilterModalClick = () => {
    let clientIds = getCSIds(customer?.selected);
    let siteIds = getCSIds(site?.selected);
    let countryIds = getCSIds(country?.selected);
    let stateIds = getCSIds(state?.selected);
    let regionIds = getCSIds(region?.selected);

    let filterText = `countryIds:${countryIds ?? ""};stateIds:${
      stateIds ?? ""
    };regionIds:${regionIds ?? ""};clientIds:${clientIds ?? ""};siteIds:${
      siteIds ?? ""
    }`;
    if (filterName === "") {
      ErrorToast("Kindly enter a filter name");
      return;
    }
    dispatch(saveFilter(filterName, DashboardWidgets, filterText));
    setShowSavedFilterSaveModal(false);
    setFilterName(null);
    //  dispatch(modalActions.showSavedFilterSaveModal(false));
    //  dispatch(filterActions.resetFilterName());
  };

  function getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState) {
    const filterKeys = [
      { key: "CustomerID", optionsKey: "customer" },
      { key: "SiteID", optionsKey: "site" },
      { key: "CountryID", optionsKey: "country" },
      { key: "StateID", optionsKey: "state" },
      { key: "Region", optionsKey: "region" },
    ];

    const filtered = {};

    filterKeys.forEach(({ key, optionsKey }) => {
      const availableValues = (DashboardWidgetsFilterState[optionsKey]?.options || []).map(opt => opt.value);
      filtered[key] = (apiFilter[key] || []).filter(val => availableValues.includes(val));
    });

    return filtered;
  }


  return (
    <div className="MainContentMargin">
      <div className="dashboardConfigHeader">
        <div className="dashboardheading configDashboardMainDiv">
          <p style={{ float: "left" }}>
            Welcome to MonitoringHub{" "}
            <span>{loggedInUser && " " + loggedInUser.FullName}</span>
          </p>
          <div className="dashboardHeadingRightDiv">
            <CountdownTimer
              key={timerKey}
              intervalSec={1}
              resetAfterSec={DASHBOARD_INTERVAL_TIMER / 1000}
              onReset={() => {
                if (
                  consolidatedDataPayload &&
                  consolidatedDataPayload.length > 0
                ) {
                  fetchConsolidatedData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
                }
                if (deviceStatusPayload && deviceStatusPayload.length > 0) {
                  fetchDeviceStatusData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
                }
                if (VBDataPayload && VBDataPayload.length > 0) {
                  fetchVBData(getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState));
                }
                if (VBTimeLineDataPayload && VBTimeLineDataPayload.length > 0) {
                  fetchVBTimeLineData();

                }
                if (
                  alertsPayload &&
                  alertsPayload.length > 0 &&
                  widgetList &&
                  widgetList.length > 0
                ) {
                  const dateRanges = [
                    ...new Set(
                      widgetList
                        .filter((w) => w.DateRange)
                        .map((w) => w.DateRange)
                    ),
                  ];
                  dateRanges.forEach((dateRangeValue) => {
                    const filteredPayload = alertsPayload.filter((payload) => {
                      const widget = widgetList.find(
                        (w) => w.WidgetID === payload.WidgetID
                      );
                      return widget && widget.DateRange === dateRangeValue;
                    });
                    if (filteredPayload.length > 0) {
                      fetchAlertsData(
                        dateRangeValue,
                        filteredPayload,
                        getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState)
                      );
                    }
                  });
                }
              }}
              running={
                (alertsPayload && alertsPayload.length > 0) ||
                (deviceStatusPayload && deviceStatusPayload.length > 0) ||
                (consolidatedDataPayload && consolidatedDataPayload.length > 0) ||
                (VBDataPayload && VBDataPayload.length > 0) ||
                (VBTimeLineDataPayload && VBTimeLineDataPayload.length > 0)
              }
            />
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip>Setting</Tooltip>}
            >
              <button className="ListGridBtn" onClick={() => getOpenMenu()}>
                <img alt="ListView" src={AlertListViewActive} />
              </button>
            </OverlayTrigger>
          </div>
        </div>
        <div className="DashboardFilterMainDiv">
          <div className="RefreshText" style={{ display: "flex" }}>
            <div className="HMFilterDiv dashboardConfigFliterDiv">
              <FilterToolDDL {...filterToolDDLProps} />
              <div>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Apply Filter</Tooltip>}
                >
                  <button
                    className={`${
                      visibleFilterBtn ? "buttonDisable" : "IconsButtonDiv"
                    }`}
                    name="filterBtn"
                    disabled={visibleFilterBtn}
                    onClick={handleFilterClick}
                  >
                    <img
                      src={FilterIcon}
                      className="camera-icon-height"
                      alt="Save filter icon"
                    />
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Clear Filter</Tooltip>}
                >
                  <button
                    className={`${
                      visibleClearFilterBtn ? "buttonDisable" : "IconsButtonDiv"
                    }`}
                    name="clearFilterBtn"
                    disabled={visibleClearFilterBtn}
                    onClick={handleClearFilterClick}
                  >
                    <img
                      src={ClearFilter}
                      className="camera-icon-height"
                      alt="Save filter icon"
                    />
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Save Filter</Tooltip>}
                >
                  <button
                    className={`${
                      visibleSaveFilterBtn ? "buttonDisable" : "IconsButtonDiv"
                    }`}
                    name="saveFilterBtn"
                    disabled={visibleSaveFilterBtn}
                    onClick={openSaveModal}
                  >
                    <img
                      src={SaveFilter}
                      className="camera-icon-height"
                      alt="Save filter icon"
                    />
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip>
                      {hasSavedLayout ? "Update layout" : "Save layout"}
                    </Tooltip>
                  }
                >
                  <button
                    className="IconsButtonDiv"
                    onClick={hasSavedLayout ? updateLayoutData : addLayoutData}
                  >
                    <img
                      src={Save}
                      className="camera-icon-height"
                      alt={hasSavedLayout ? "update icon" : "save icon"}
                    />
                  </button>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>
      </div>
      {getLayoutLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
            width: "100%",
          }}
        >
          <CircularProgress />
          <span style={{ marginTop: "1rem", color: "#888", fontWeight: 500 }}>
            Loading Layout
          </span>
        </div>
      ) : widgetListLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
            width: "100%",
          }}
        >
          <CircularProgress />
          <span style={{ marginTop: "1rem", color: "#888", fontWeight: 500 }}>
            Loading
          </span>
        </div>
      ) : widgetListError ? (
        <AlertTemplateMessage message={widgetListError} />
      ) : (
        <DynamicWidgetStructure
          setOpen={setOpen}
          open={open}
          widgetList={widgetList}
          setAlertsPayload={setAlertsPayload}
          setConsolidatedDataPayload={setConsolidatedDataPayload}
          setDeviceStatusPayload={setDeviceStatusPayload}
          setVBDataPayload={setVBDataPayload}
          setVBTimeLineDataPayload={setVBTimeLineDataPayload}
          consolidatedData={consolidatedData}
          deviceStatus={deviceStatus}
          alertsData={alertsData}
          VBData={VBData}
          VBTimeLineData={VBTimeLineData}
          selectedDate={selectedDate} // this is related to VBTimeLineData, so we need to pass it down to the component
          setSelectedDate={setSelectedDate}
          isDarkTheme={isDarkTheme}
          filteredLayout={filteredLayout}
          apiFilter={getFilteredApiFilter(apiFilter, DashboardWidgetsFilterState)}
        />
      )}
      {/* Modal popup for save filter */}
      <Modal
        size="lg"
        show={showSavedFilterSaveModal}
        onHide={() => setShowSavedFilterSaveModal(false)}
        dialogClassName="modal-90w"
        backdrop="static"
        className="saveCameraFilterModal"
      >
        <>
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              Save Filter
            </Modal.Title>
            <img
              src={RemoveIcon}
              alt="Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowSavedFilterSaveModal(false);
                setFilterName(null);
              }}
            />
          </Modal.Header>

          <Modal.Body>
            <div className="inputMainContainer w40dot75rem w-100">
              <div className="inputTypeLabelContainer">
                <label className="formFieldLabels">Filter Name</label>
                <input
                  style={{ width: "40vw" }}
                  type="text"
                  className="inputType"
                  value={filterName}
                  placeholder="Ex. Filter for xyz company with 10 sites"
                  onChange={handleFilterNameInputChange}
                />
                <p className="Error_P" style={{ float: "left" }}>
                  <span>{}</span>
                </p>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                className="DataAccessEdit mt-3"
                style={{ width: "250px" }}
                onClick={handleSaveFilterModalClick}
                disabled={!filterName}
              >
                <span className="ViewUpdate">Save</span>
              </button>
            </div>
          </Modal.Body>
        </>
      </Modal>

      <Modal
        size="lg"
        show={showSavedFilterDeleteModal}
        onHide={() => setShowSavedFilterDeleteModal(false)}
        className="deleteModalMainClass"
        backdrop="static"
        // centered
      >
        <Modal.Body>
          <div className="ModalBodyDiv">
            <div style={{ padding: "37px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <img
                  className="informationIcon infoorangeicon"
                  src={WarningDelete}
                  alt="Info"
                />
                <div style={{ width: "100%" }}>
                  <h3 className="No-Data-Access-Group">Delete Saved Filter!</h3>
                </div>
              </div>
              <p className="DeleteText mb-4">
                Are you sure you want to delete the saved filter
                <br />
                <span className="font-weight-bold">
                  {savedFilters?.selected?.filterName}
                </span>
              </p>
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <button
                  className="DataAccessEdit ml-0"
                  style={{ width: "45%", backgroundColor: "#FB3030" }}
                  onClick={handleDeleteSavedFilterModalYesClick}
                >
                  <span className="ViewUpdate">Yes</span>
                </button>
                <button
                  onClick={handleDeleteSavedFilterNoClick}
                  className="DataAccessEdit ml-0"
                  style={{ width: "45%" }}
                >
                  <span className="ViewUpdate">No</span>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="xl"
        show={openInfoFilter}
        onHide={() => setOpenInfoFilter(false)}
        className="deleteModalMainClass"
        backdrop="static"
        // centered
        scrollable
      >
        <Modal.Header>
          <Modal.Title id="example-custom-modal-styling-title">
            {modalFilterName} - info
          </Modal.Title>
          <img
            src={RemoveIcon}
            alt="Remove"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setOpenInfoFilter(false);
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <div id="mainContainer" className="main-container">
            {customerInfoArr?.length > 0 && (
              <InfoComponent
                headerName={"Customer"}
                infoArr={customerInfoArr}
              />
            )}
            {countryInfoArr?.length > 0 && (
              <InfoComponent headerName={"Country"} infoArr={countryInfoArr} />
            )}
            {regionInfoArr?.length > 0 && (
              <InfoComponent headerName={"Region"} infoArr={regionInfoArr} />
            )}
            {stateInfoArr?.length > 0 && (
              <InfoComponent headerName={"State"} infoArr={stateInfoArr} />
            )}
            {siteInfoArr?.length > 0 && (
              <InfoComponent headerName={"Site"} infoArr={siteInfoArr} />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Dashboard;
